/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiCostcentersIdMutationResponse,
  DeleteApiCostcentersIdPathParams,
} from '../models/DeleteApiCostcentersId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiCostcentersIdMutationResponseSchema } from '../zod/deleteApiCostcentersIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiCostcentersIdMutationKey = () =>
  [{ url: '/api/costCenters/:id' }] as const;

export type DeleteApiCostcentersIdMutationKey = ReturnType<
  typeof deleteApiCostcentersIdMutationKey
>;

/**
 * {@link /api/costCenters/:id}
 */
export async function deleteApiCostcentersId(
  id: DeleteApiCostcentersIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiCostcentersIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/costCenters/${id}`,
    ...requestConfig,
  });
  return deleteApiCostcentersIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/costCenters/:id}
 */
export function useDeleteApiCostcentersId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiCostcentersIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiCostcentersIdPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiCostcentersIdMutationKey();

  return useMutation<
    DeleteApiCostcentersIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiCostcentersIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiCostcentersId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
